import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {getPdf} from '../services/surveyHelpDoc.service';
import {useLocation} from "react-router-dom";
import {AEU_PDF_ERROR} from "../utils/surveyLiterals";
import {Typography, FormLabel} from "@deere/fuel-react";
import { useOktaAuth } from '@okta/okta-react';
import { getTranslation } from "../utils/utils";

export const PDFViewer = ({q, survey,accessToken}) => {
    const [url,setUrl] = useState(undefined);
    const [surveyId, setSurveyId] = useState(undefined);
    const [campaignId, setCampaignId] = useState(undefined);
    const campaign = useSelector(state => state.campaign.campaignAssigned);
    const location = useLocation()
    const { authState } = useOktaAuth();
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    useEffect(() => {
        if(location && location.state && location.state.campaign && location.state.previous){
            if(location.state.campaign.id && (location.state.previous === '/survey' || location.state.previous === '/details') ){
                setCampaignId(location.state.campaign.id)
            }else {
                setCampaignId(location.state.campaign.campaignId)
            }
        } else if (campaign && campaign.id){
            setCampaignId(campaign.id)
        }
        setSurveyId(survey.id);

        if( survey && surveyId && campaignId && q && q.id ){
            getPdf(surveyId, campaignId, q.id, accessToken, isAuthMethodOkta).then(async (response) => {
                if(response.status === 200){
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob)
                    setUrl(url)
                }
            })
                .catch((err) => {
                   console.log(err)
                });
        }
    }, [location,campaign, campaignId]);

    return url ? (
        <>
          <FormLabel className="uxf-label" >{getTranslation(q, 'text')}</FormLabel>
          <iframe src={`${url}#toolbar=0`} width={"100%"} height={"350"} />
        </>
      ) : (
        <Typography color="error" gutterBottom>
          {AEU_PDF_ERROR}
        </Typography>
      );
}